import axios from "axios";

const API = axios.create({
  baseURL: "https://api.allianceprotravaux.be/api",
//   withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default API;